import { render } from "./OnfidoSdkWrapper.vue?vue&type=template&id=d4324234&scoped=true"
import script from "./OnfidoSdkWrapper.vue?vue&type=script&lang=js"
export * from "./OnfidoSdkWrapper.vue?vue&type=script&lang=js"

import "./OnfidoSdkWrapper.vue?vue&type=style&index=0&id=d4324234&scoped=true&lang=css"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4324234"]])

export default __exports__